import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Typography as MuiTypography,
  Stack as MuiStack,
  Box as MuiBox,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const SummarySection = ({ items, label, noItemsLabel }) => {
  const hasItems = items && items.length > 0;

  return (
    <MuiStack>
      <MuiTypography
        sx={{ fontSize: "14px", fontWeight: "700", lineHeight: "21px" }}
      >
        {hasItems ? label : noItemsLabel}
      </MuiTypography>
      {hasItems && (
        <MuiBox component="ul" sx={{ m: 0, pl: 3 }}>
          {items.map((item, index) => (
            <MuiTypography
              key={index}
              component="li"
              sx={{ fontSize: "14px", lineHeight: "1.5" }}
            >
              {item}
            </MuiTypography>
          ))}
        </MuiBox>
      )}
    </MuiStack>
  );
};

const RecentActivityDialog = ({
  isOpen,
  onClose,
  filename,
  rowType,
  recentActivitySummary,
}) => {
  const { t } = useTranslation();
  const summaryData = recentActivitySummary?.[0] || {};

  return (
    <MuiDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="ois-recent-activity-dialog-title"
      aria-describedby="ois-recent-activity-dialog-description"
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: "605px",
        },
      }}
    >
      <MuiDialogTitle
        id="ois-recent-activity-dialog-title"
        sx={{
          padding: "16px 24px",
          fontSize: "18px",
        }}
      >
        {t("ois.dialog.recentActivityErrors.title.info")}
        <MuiStack direction="row" spacing={0.5}>
          <MuiTypography
            sx={{ fontSize: "14px", fontWeight: "700", lineHeight: "1em" }}
          >
            {t("ois.dialog.recentActivityErrors.label.transactions")}
          </MuiTypography>
          <MuiTypography sx={{ fontSize: "14px", lineHeight: "1em" }}>
            {rowType}
          </MuiTypography>
        </MuiStack>
        <MuiStack direction="row" spacing={0.5}>
          <MuiTypography
            sx={{ fontSize: "14px", fontWeight: "700", lineHeight: "1em" }}
          >
            {t("ois.dialog.recentActivityErrors.label.file")}
          </MuiTypography>
          <MuiTypography sx={{ fontSize: "14px", lineHeight: "1em" }}>
            {filename}
          </MuiTypography>
        </MuiStack>
      </MuiDialogTitle>

      <MuiDialogContent
        dividers
        sx={{
          padding: "24px",
          gap: "28px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <SummarySection
          items={summaryData.errors}
          label={t("ois.dialog.recentActivityErrors.label.errors")}
          noItemsLabel={t("ois.dialog.recentActivityErrors.label.noErrors")}
        />
        <SummarySection
          items={summaryData.messages}
          label={t("ois.dialog.recentActivityErrors.label.messages")}
          noItemsLabel={t("ois.dialog.recentActivityErrors.label.noMessages")}
        />
        <SummarySection
          items={summaryData.warnings}
          label={t("ois.dialog.recentActivityErrors.label.warnings")}
          noItemsLabel={t("ois.dialog.recentActivityErrors.label.noWarnings")}
        />
      </MuiDialogContent>

      <MuiDialogActions>
        <MuiButton color="primary" onClick={onClose} sx={{ fontSize: "17px" }}>
          {t("buttons.standard.close")}
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default RecentActivityDialog;
